// @ts-check
import {Tag} from '@/components/atoms'
import {cn} from '@/helpers/shadcn/utils'
import {useSortable} from '@dnd-kit/react/sortable'
import {Font, Icon} from 'pepsico-ds'
import {memo} from 'react'
import {getCatalogItemName} from './utils/productCatalogUtils'

/**
 * @param {{subcategory: import('@/types/productCatalogTypes').ProductSubcategory, index: number, onToggleVisibility: () => void}} props
 */
const SubcategoryItemComponent = ({subcategory, index, onToggleVisibility}) => {
  const {id, name, productCount, visible} = subcategory
  const {ref, handleRef, isDragging} = useSortable({id, index})
  const subcategoryName = getCatalogItemName({id, name})

  return (
    <div
      ref={ref}
      className={`flex items-center justify-between rounded-lg border border-gray-600 p-4 ${isDragging ? 'opacity-50' : ''}`}
      style={{contentVisibility: 'auto', containIntrinsicSize: '72px'}}
    >
      <div className="flex items-center gap-4">
        <button ref={handleRef} className="cursor-grab touch-none">
          <Icon icon="drag_indicator" />
        </button>
        <Font className="font-semibold text-gray-400">{index + 1}.</Font>
        <Font className={cn(!visible && 'text-gray-400 line-through')}>{subcategoryName}</Font>
      </div>
      <div className="flex items-center gap-4">
        <Tag
          text={
            <div className="flex items-center">
              <p>{`${productCount} products`}</p>
              <Icon size="small" icon="chevron_right" />
            </div>
          }
          color="blue"
          type="outlined"
        />
        <button
          onClick={onToggleVisibility}
          className={
            visible ? 'text-[var(--color-feedback-info-high-contrast)]' : 'text-[var(--color-interaction-disabled)]'
          }
        >
          <Icon size="small" icon={visible ? 'visibility' : 'visibility_off'} />
        </button>
      </div>
    </div>
  )
}

export const SubcategoryItem = memo(SubcategoryItemComponent)
